import axios from "@/axios";

export const namespaced = true

const defaultData = {
    implimentArrangementId: 0,
    acsaAgreementId: 0,
    created:null,
    updated:null,
    name: null,
    remark: null,
    files: []
}

export const state = {
    implementArrangments: [],
    countryImplementArrangements: [],
    implementArrangment: defaultData,
    countryUpdated: 0,
}

export const getters = {
        implementArrangments: (state) => state.implementArrangments,
        countryImplementArrangments: (state) => state.countryImplementArrangements,
        implementArrangment: (state) => state.implementArrangment,
        countryUpdated: (state) => state.countryUpdated,       
}
    
export const mutations = {
    SET_IMPLEMENT_ARRANGMENTS: (state, resp) => (state.implementArrangments = resp.data),
    SET_COUNTRY_IMPLEMENT_ARRANGMENTS: (state, resp) => (state.countryImplementArrangements = resp.data),
    SET_IMPLEMENT_ARRANGMENT: (state, resp) => (state.implementArrangment = Object.assign({}, defaultData, resp.data)),
    SET_COUNTRY_UPDATED: (state, val)=> (state.countryUpdated = state.countryUpdated + val ) 
}

export const actions = {
        async getAllImplementArrangments({commit}) {
            const response = await axios.get("/api/implimentarrangements");
            commit('SET_IMPLEMENT_ARRANGMENTS', response)
        },
        async getCountryImplementArrangments({commit}, id) {
            const response = await axios.get(`/api/countries/arrangement/${id}`);
            commit('SET_COUNTRY_IMPLEMENT_ARRANGMENTS', response)
        },
        async getImplementArrangment({commit}, id) {
            const response = await axios.get(`/api/implimentarrangements/${id}`);
            commit('SET_IMPLEMENT_ARRANGMENT', response)
    },
    getCountryUpdatedCount({ commit }, val) {
            commit('SET_COUNTRY_UPDATED' , val)
        }
}
